import {
  IRollObjectStyleConfiguration,
  IBackgroundColorConfiguration,
  IBorderColorConfiguration,
  IObjectColorConfiguration,
  IEnableConfiguration,
} from "../../../../domain/configuration";
import {
  PaintStyle,
  TextStyle,
} from "../../../../domain/drawing";
import {
  RollItem,
} from "../../../../domain/document/items";
import { AbstractTextObjectStyleReader } from "./AbstractTextObjectStyleReader";
import { FixedColorSource } from ".";

export class RollObjectStyleReader extends AbstractTextObjectStyleReader<RollItem> {
  constructor(private readonly _configuration: IRollObjectStyleConfiguration) {
    super();
  }

  protected readSpecifiedPaintStyle(source: RollItem, shouldInputFree: boolean): PaintStyle {
    return null;
  }

  protected readBackgroundColorConfiguration(source: RollItem, shouldInputFree: boolean): IBackgroundColorConfiguration {
    return this.readObjectStyleConfiguration(source);
  }
  
  protected readBorderColorConfiguration(source: RollItem, shouldInputFree: boolean): IBorderColorConfiguration {
    return this.readObjectStyleConfiguration(source);
  }

  private readObjectStyleConfiguration(source: RollItem): IObjectColorConfiguration {
    if (source.injectedRule && source.injectedRule.isEditDisabled) {
      return FixedColorSource.uneditable;
    }
    return this._configuration.default;
  }

  public readTextStyle(source: RollItem, shouldInputFree: boolean, isFocused: boolean): TextStyle {
    return ((source.shouldInputFree || (source.isFreeInputable && shouldInputFree)) && isFocused)
      ? this.toFreeInputTextStyle(source)
      : this.toTextStyle(source);
  }

  protected readForegroundDisplayConfiguration(): IEnableConfiguration {
    return this._configuration.foreground;
  }
}
